var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterOne4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.05203 21.8495L6.82869 5.96616C6.87781 5.83047 6.96041 5.70937 7.06881 5.61411C7.17722 5.51885 7.30792 5.45251 7.4488 5.42124C7.58969 5.38997 7.73619 5.39478 7.87471 5.43523C8.01324 5.47568 8.13931 5.55046 8.24123 5.65263L18.349 15.7604C18.4509 15.8624 18.5254 15.9885 18.5656 16.127C18.6059 16.2654 18.6105 16.4118 18.5791 16.5525C18.5478 16.6932 18.4814 16.8238 18.3862 16.932C18.291 17.0403 18.17 17.1228 18.0344 17.1719L2.15103 22.9485C1.99765 23.0046 1.83144 23.0156 1.67199 22.9803C1.51254 22.9451 1.36648 22.865 1.251 22.7495C1.13553 22.6341 1.05546 22.488 1.02021 22.3286C0.984954 22.1691 0.995994 22.0029 1.05203 21.8495Z",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0801 7.1604C15.0801 7.1604 15.0801 4.52014 17.7203 4.52014C20.3606 4.52014 20.3606 1.87988 20.3606 1.87988",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4395 1V3.64026",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3594 11.561L22.1195 13.3212",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3594 8.04024L22.9996 7.16016",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 10.4712L13.5285 18.8122",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72083 20.924L3.07617 16.2793",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterOne4);
export default __webpack_public_path__ + "static/media/footer-one-4.e9a15fe1331c84351d75bac1b1763cbc.svg";
export { ForwardRef as ReactComponent };